import { fetchCarHireReservation } from 'actions/CarHireActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect } from 'react'

const EmptyState: App.CarHireReservationInfo = {
  reservation: undefined,
  error: undefined,
  fetching: false,
}

function useCarHireReservationInfo(reservationId: string, purchasingCustomerId?: string) {
  const dispatch = useAppDispatch()

  const reservation = useAppSelector(state => state.carHire.reservationInfo[reservationId] ?? EmptyState)

  useEffect(() => {
    if (reservationId) dispatch(fetchCarHireReservation(reservationId, purchasingCustomerId))
  }, [dispatch, purchasingCustomerId, reservationId])

  return reservation
}

export default useCarHireReservationInfo
